export default __webpack_public_path__ + "static/media/qs-dropdown.1ad51f4e.webp";